import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');

export default function ImgG() {
    const { useLang, isMobile } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    return (
        <div className={`imgG ${css.imgG} ${isMobile ? 'imgG_h5' : 'imgG_pc'}`}>
            <div className="imgBox">
                <EFPic
                    name={[`${isMobile ? 'h5/' : 'pc/'}5.webp`, `${isMobile ? 'h5/' : 'pc/'}5.jpg`]}
                    // layout="fill"
                    className="fullImgs"
                    alt={t('dg200.textIconF_title')}
                    aria-label={t('dg200.textIconF_title')}
                />
            </div>
        </div>
    );
}
